export const storeColumns = (t: any) => [
    {
        key: "storeName",
        name: t('store.columns.storeName'),
        fieldName: "storeName",
        minWidth: 250,
        maxWidth: 300,
        isResizable: true,
    },
    {
        key: "receptionPlace",
        name: t('store.columns.receptionPlace'),
        fieldName: "receptionPlaceName",
        minWidth: 350,
        maxWidth: 500,
        isResizable: true,
    },
    {
        key: "containersAmount",
        name: t('store.columns.containersAmount'),
        fieldName: "containersAmount",
        minWidth: 350,
        maxWidth: 500,
        isResizable: true,
    }
];